<template>
  <v-dialog
    persistent
    v-model="dialog"
    scrollable
    @keydown.esc="dialog = false"
    width="850"
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Description"
                v-model="selectedLuNoteType.Description"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Internal Only"
                v-model="selectedLuNoteType.InternalOnly"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedLuNoteType.IsActive"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveLuNoteTypeDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuNoteType from '@classes/LuNoteType'
//templateTODO: import lookup components you plan to use
export default {
  components: {
    //templateTodo: define lookup components you are using
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedLuNoteType: new LuNoteType(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('luNoteType', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('luNoteType', ['saveLuNoteType']),
    async validate() {
      await this.$refs.form.validate()
    },
    editLuNoteType(entry) {
      this.selectedLuNoteType = new LuNoteType(entry)
      this.modalText = 'Edit Note Type'
      this.dialog = !this.dialog
    },
    addLuNoteType() {
      this.modalText = 'Insert Note Type'
      this.selectedLuNoteType = new LuNoteType()
      this.dialog = !this.dialog
    },
    async saveLuNoteTypeDetails() {
      await this.validate()
      if (this.valid) {
        //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
        try {
          await this.saveLuNoteType(this.selectedLuNoteType.removeRelated())
          this.$emit('refresh')
          this.$emit('itemAdded', res.data)
          this.selectedLuNoteType = new LuNoteType()
          this.$refs.form.resetValidation()
        } catch (err) {}
        this.dialog = false
      }
    },
    cancelEntry() {
      this.dialog = false
      this.selectedLuNoteType = new LuNoteType()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
